import { all, call } from "redux-saga/effects";

import administrationRootSaga from "./administrationRootSaga";
import grhRootSaga from "./grhRootSaga";
import onboardingRootSaga from "./onboardingRootSaga";
import formationRootSaga from "./formationRootSaga";
import skillsRootSaga from "./skillsRootSaga";
import kmsRootSaga from "./kmsRootSaga";
import recrutementRootSaga from "./recrutementRootSaga";
import performanceRootSaga from "./performanceRootSaga";

export default function* moduleRootSagas() {
  yield all([
    call(administrationRootSaga),
    call(grhRootSaga),
    call(onboardingRootSaga),
    call(formationRootSaga),
    call(skillsRootSaga),
    call(kmsRootSaga),
    call(recrutementRootSaga),
    call(performanceRootSaga),
  ]);
}
